import { ReasoningStep } from '../store/dashboard/askAica/actions';

/**
 * Accumulates the latest streamed reasoning step onto the in-flight turn's
 * reasoning message. Shared by both the leads (store/dashboard/askAica) and
 * portfolio (store/globalAskAica) reducers' setReasoning handlers so the
 * accumulation formula only has one place to fix.
 *
 * Returns `current` unchanged (via the caller's own isEmpty/hasNewReasoning
 * guard) when there is nothing new to accumulate — callers check that before
 * calling this helper.
 */
export const accumulateReasoning = (current: ReasoningStep | undefined, steps: ReasoningStep[]): ReasoningStep => {
    const latestReasoning = steps[steps.length - 1];
    return current ? { ...current, message: current.message + latestReasoning.message } : latestReasoning;
};
